
//   $(document).ready(function(){
//     $('.text-with-icons__button a').on('click', function(e){
//       e.preventDefault();
//       $('html, body').animate({
//         scrollTop: $('#shopify-section-template--25074261033257__join_form_TNttxf').offset().top - 50
//       }, 800);
//     });
//   });


// document.getElementById('fileUpload').addEventListener('change', async function(e) {
//   const file = e.target.files[0];
//   const formData = new FormData();
//   formData.append('file', file);

//   // Upload using Shopify file API endpoint
//   const res = await fetch('/upload', {
//     method: 'POST',
//     body: formData
//   });

//   const data = await res.json();
//   document.getElementById('fileUrl').value = data.files[0].url;
// });


// // trigger click

//   $('.collapsible-content.is-open-default').trigger('click');
  
  
  
//   // .each(function () {
//   //   const contentId = $(this).attr('id');
//   //   const $trigger = $('[aria-controls="' + contentId + '"]');

//   //   if ($trigger.length && $trigger.attr('aria-expanded') !== 'true') {
//   //     $trigger.trigger('click');
//   //   }
//   // });


document.addEventListener("DOMContentLoaded", function () {

  document.addEventListener("click", function(event) {

    const sampleBtn = event.target.closest("#order-sample-btn");
    if (!sampleBtn) return;

    event.preventDefault();
    event.stopPropagation();

    const sampleId = parseInt(sampleBtn.getAttribute("data-sample-variant-id"));
    const MAX_QTY = 4;

    if (sampleBtn.disabled) return;

    // 🔎 STEP 1: Get Current Cart
    fetch('/cart.js')
      .then(res => res.json())
      .then(cart => {

        const existingItem = cart.items.find(item => item.id === sampleId);

        // 🧠 If item already exists
        if (existingItem) {

          const newQty = existingItem.quantity + 1;

          // ❌ Stop if already reached max
          if (existingItem.quantity >= MAX_QTY) {

  // Find the message div
          const msg = document.querySelector('.Quantity-limit-message');

          if (msg) {
            msg.classList.add('show');

            // Optional: auto-hide after 3 sec
            setTimeout(() => {
              msg.classList.remove('show');
            }, 3000);
          }

          return;
        }


          // ✅ Update quantity instead of adding new line
          return fetch('/cart/change.js', {
            method: 'POST',
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
              id: existingItem.key, // IMPORTANT: use key, not variant id
              quantity: newQty
            })
          });

        }

        // ➕ If NOT in cart → add first time
        return fetch('/cart/add.js', {
          method: 'POST',
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            id: sampleId,
            quantity: 1,
             properties: {
            "Type": "Sample Product"
          }
          })
        });

      })
      .then(r => r && r.json())
      .then((data) => {

        if (!data) return;

        // 🔄 Refresh cart drawer like theme
        document.dispatchEvent(
          new CustomEvent("ajaxProduct:added", {
            detail: { product: data }
          })
        );

      })
      .catch(err => console.error(err));

  });

  
});





